import { useEffect, useState } from "react";
import axios from "axios";
import CommonCard from "../ui/CommonCard/CommonCard";
import SearchInput from "../ui/SearchInput/SearchInput";
import classes from "./ManageDocs.module.css";
import { env } from "../../constants/env";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../ReusableTable/ReusableTable";

const ManageDocs = () => {
  const navigate = useNavigate();
  const [docs, setDocs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // same as backend default
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("formioToken");

  const [searchTerm, setSearchTerm] = useState(""); // raw input
  const [search, setSearch] = useState(""); // debounced value

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(searchTerm);
      setPage(1); // reset to first page when searching
    }, 500); // wait 0.5s after typing

    return () => clearTimeout(timeout);
  }, [searchTerm]);

  useEffect(() => {
    fetchDocs();
  }, [page, search]);

  const fetchDocs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${env.apiUrl}/api/submissions/stage/usage`, {
        params: { page, limit, search },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDocs(res.data.submissions);
      setCount(res.data.count);
    } catch (err) {
      console.error("Error fetching docs:", err);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(count / limit);

  return (
    <div className={classes.wrapper}>
      <h5>Manage documents</h5>
      <ReusableTable
        data={docs}
        loading={loading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        page={page}
        limit={limit}
        count={count}
        totalPages={totalPages}
        setPage={setPage}
        onRowClick={(doc) =>
          navigate(`/activity/submitted-documents/${doc._id}`)
        }
        columns={[
          {
            key: "formName",
            label: "Document name",
            className: classes.docName,
          },
          { key: "formTag1", label: "Document ref #" },
          {
            key: "formStage",
            label: "Status",
            render: (val) => (
              <div className={classes.statusCell}>
                <div className={classes.progressBar}>
                  <div className={classes.progress}></div>
                </div>
                <span className={classes.statusText}>{val}</span>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default ManageDocs;
